import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    event.preventDefault();
    event.stopPropagation();
    const url = event.currentTarget.dataset.url;

    this.contentTarget.innerHTML = '<p class="has-text-grey">Loading...</p>';
    this.modalTarget.classList.add('is-active');

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.text())
      .then(html => { this.contentTarget.innerHTML = html; })
      .catch(() => { this.contentTarget.innerHTML = '<p class="has-text-danger">Failed to load source document.</p>'; });
  }

  close(event) {
    event.preventDefault();
    event.stopPropagation();
    this.modalTarget.classList.remove('is-active');
  }
}
